import { render, staticRenderFns } from "./BuyersCooperationUsersDialog.vue?vue&type=template&id=e04ac3ec&scoped=true&"
import script from "./BuyersCooperationUsersDialog.vue?vue&type=script&lang=js&"
export * from "./BuyersCooperationUsersDialog.vue?vue&type=script&lang=js&"
import style0 from "./BuyersCooperationUsersDialog.vue?vue&type=style&index=0&id=e04ac3ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04ac3ec",
  null
  
)

export default component.exports